/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BusinessexamplecomInputs */

const en_businessexamplecom = /** @type {(inputs: BusinessexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`business@example.com`)
};

const de_businessexamplecom = /** @type {(inputs: BusinessexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`business@example.com`)
};

/**
* | output |
* | --- |
* | "business@example.com" |
*
* @param {BusinessexamplecomInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const businessexamplecom = /** @type {((inputs?: BusinessexamplecomInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BusinessexamplecomInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessexamplecom(inputs)
	return de_businessexamplecom(inputs)
});